import { render, staticRenderFns } from "./adminTutorials.vue?vue&type=template&id=045a9744"
import script from "./adminTutorials.vue?vue&type=script&lang=js"
export * from "./adminTutorials.vue?vue&type=script&lang=js"
import style0 from "./adminTutorials.vue?vue&type=style&index=0&id=045a9744&prod&lang=css"
import style1 from "./adminTutorials.vue?vue&type=style&index=1&id=045a9744&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports